module.exports = __webpack_public_path__ + "bin/24b64f0298b40edd7f5d6e5e50e5ea63.jpg";